import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import EventIcon from '@mui/icons-material/Event';

const AppList: React.FC = () => (
  <Box sx={{ maxWidth: 680, mx: 'auto', p: { xs: 3, sm: 5 }, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: "24px" }}>
    <EventIcon sx={{ color: 'primary.main', fontSize: 36, mb: 3 }} />
    <Typography component="h1" variant="h4" sx={{ mb: 2 }}>予約代行システム</Typography>
    <Typography color="text.secondary" sx={{ mb: 4, lineHeight: 1.9 }}>診察券と希望日時を登録して、医院への予約を依頼できます。</Typography>
    <Button component={Link} to="/reservation/menu" variant="contained" size="large">予約メニューを開く</Button>
  </Box>
);

export default AppList;
